// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menus-page {
  padding-top: 24px;
  padding-bottom: 48px;
  text-align: center;
}

.menus-page__title {
  margin: 0 auto 28px;
  max-width: 900px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: clamp(32px, 4vw, 48px);
  line-height: 1.15;
  color: #4e3f3a;
}

.menus-page__message {
  margin: 0 auto;
  max-width: 640px;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #4e3f3a;
}

.menus-page__message--error {
  color: #c00;
}

.menus-page__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 32px 24px;
  max-width: 1100px;
  margin: 0 auto;
  justify-items: center;
}

.menus-page__card {
  width: 100%;
  max-width: 340px;
  min-height: 220px;
  border: 1px solid #fff;
  border-radius: 26px;
  background: linear-gradient(180deg, #fff9ef 0%, #f3e3cc 100%);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  overflow: hidden;
}

.menus-page__card-image {
  display: block;
  width: 100%;
  height: 140px;
  flex-shrink: 0;
  background-color: #e8e4df;
  background-size: cover;
  background-position: center;
}

.menus-page__card-image--empty {
  background-image: linear-gradient(135deg, #e8e4df 0%, #d4cdc4 100%);
}

.menus-page__card-caption {
  padding: 16px 20px 20px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: clamp(20px, 2.2vw, 28px);
  line-height: 1.2;
  color: #4e3f3a;
}

@media (max-width: 1024px) {
  .menus-page__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .menus-page__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MenusPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,6DAA6D;EAC7D,wCAAwC;EACxC,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".menus-page {\n  padding-top: 24px;\n  padding-bottom: 48px;\n  text-align: center;\n}\n\n.menus-page__title {\n  margin: 0 auto 28px;\n  max-width: 900px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n  font-size: clamp(32px, 4vw, 48px);\n  line-height: 1.15;\n  color: #4e3f3a;\n}\n\n.menus-page__message {\n  margin: 0 auto;\n  max-width: 640px;\n  font-family: 'Roboto', sans-serif;\n  font-size: 16px;\n  color: #4e3f3a;\n}\n\n.menus-page__message--error {\n  color: #c00;\n}\n\n.menus-page__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 32px 24px;\n  max-width: 1100px;\n  margin: 0 auto;\n  justify-items: center;\n}\n\n.menus-page__card {\n  width: 100%;\n  max-width: 340px;\n  min-height: 220px;\n  border: 1px solid #fff;\n  border-radius: 26px;\n  background: linear-gradient(180deg, #fff9ef 0%, #f3e3cc 100%);\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  text-align: left;\n  overflow: hidden;\n}\n\n.menus-page__card-image {\n  display: block;\n  width: 100%;\n  height: 140px;\n  flex-shrink: 0;\n  background-color: #e8e4df;\n  background-size: cover;\n  background-position: center;\n}\n\n.menus-page__card-image--empty {\n  background-image: linear-gradient(135deg, #e8e4df 0%, #d4cdc4 100%);\n}\n\n.menus-page__card-caption {\n  padding: 16px 20px 20px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n  font-size: clamp(20px, 2.2vw, 28px);\n  line-height: 1.2;\n  color: #4e3f3a;\n}\n\n@media (max-width: 1024px) {\n  .menus-page__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 700px) {\n  .menus-page__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
